import type {
  ValidationResult,
  YachtGameState,
  YachtTurnState,
} from "../types";

export function valid(): ValidationResult {
  return { valid: true };
}

export function invalid(
  error: string,
  details?: Record<string, unknown>,
): ValidationResult {
  return { valid: false, error, details };
}

export function getOpenTurnSlot(
  state: YachtGameState,
  playerId: string,
): YachtTurnState | null {
  const slot = state.turnSlotsByPlayerId[playerId];
  if (!slot || slot.status !== "OPEN") return null;
  return slot;
}

export function validateActionWindow(
  slot: YachtTurnState,
  action: { readonly sheetRound: number; readonly turnNumber: number },
): ValidationResult {
  if (slot.sheetRound !== action.sheetRound) {
    return invalid("Action targets a stale sheet round");
  }
  if (slot.turnNumber !== action.turnNumber) {
    return invalid("Action targets a stale turn");
  }
  return valid();
}
